import React from 'react';
import {
  Box,
  CircularProgress,
  Alert,
  Grid,
  Pagination,
  useMediaQuery,
  Typography,
} from '@mui/material';
import UserRankCard from './UserRankCard';
import { useTranslation } from 'react-i18next';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const UsersList = ({
  users,
  loading,
  error,
  currentUserId,
  timeFrame,
  pagination,
  onPageChange,
}) => {
  const { t } = useTranslation('leaderboard');
  const isMobile = useMediaQuery('(max-width: 600px)');
  // Если происходит загрузка данных
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Если произошла ошибка
  if (error) {
    return (
      <Box my={3}>
        <Alert severity="error">
          {typeof error === 'string' ? error : t('leaderboard:errorLoading')}
        </Alert>
      </Box>
    );
  }

  // Если пользователей нет
  if (!users?.length) {
    return (
      <Box my={3} textAlign="center">
        <Typography variant="h6" color="text.secondary">
          {t('leaderboard:noUsers')}
        </Typography>
      </Box>
    );
  }

  // Разделение пользователей на топ-3 и остальных
  const topThreeUsers = users.filter((user) => user.rank <= 3);
  const otherUsers = users.filter((user) => user.rank > 3);

  return (
    <Box>
      {/* Топ-3 пользователя */}
      {topThreeUsers.length > 0 && (
        <Box mb={4}>
          <Typography
            variant="h5"
            mb={3}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <EmojiEventsIcon sx={{ color: '#FFD700' }} />
            {t('leaderboard:topThree')}
          </Typography>
          <Grid container spacing={isMobile ? 2 : 4} mb={isMobile ? 2 : 4}>
            {topThreeUsers.map((user) => (
              <Grid item key={user._id} xs={12} md={4}>
                <UserRankCard
                  user={user}
                  isCurrentUser={user._id === currentUserId}
                  isTopThree={true}
                  showRank={true}
                  timeFrame={timeFrame}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* Остальные пользователи */}
      {otherUsers.length > 0 && (
        <Box>
          <Typography variant="h5" mb={3}>
            {t('leaderboard:otherUsers')}
          </Typography>
          <Grid container spacing={3}>
            {otherUsers.map((user) => (
              <Grid item key={user._id} xs={12} sm={6} md={4}>
                <UserRankCard
                  user={user}
                  isCurrentUser={user._id === currentUserId}
                  isTopThree={false}
                  showRank={true}
                  timeFrame={timeFrame}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* Пагинация */}
      {pagination && pagination.pages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Pagination
            count={pagination.pages}
            page={pagination.page}
            onChange={(event, page) => onPageChange(page)}
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </Box>
  );
};

export default UsersList;
